import httpClientInstants from "libs/utils/HttpClient";
import { useEffect } from "react";
import { useSelector } from "react-redux";

function useAuth() {
  const accessToken = useSelector((state) => state.auth?.accessToken);
  const userRole = useSelector((state) => state.auth?.role);
  const currentUserRole = useSelector((state) => state.auth?.currentRole);
  const TypeOfUser = useSelector(
    (state) => state.personal?.detail?.smartserviceGroupID
  );
  // const TypeOfUser = null;
  const isLogin = !!accessToken;

  useEffect(() => {
    httpClientInstants.setToken(accessToken);
  }, [accessToken]);

  return {
    isLogin,
    accessToken,
    userRole,
    currentUserRole,
    TypeOfUser,
  };
}

export default useAuth;
